export default __webpack_public_path__ + "i18n/translations/translation-tr.8e4554cd.json";